<div class="lay-wrapper">
    <div class="m-content m-content--contact m-content--large">
        <div class="info">{{ 'contact.editorial.headline' | translate }}</div>
        <div class="editorial-table-wrapper">
            <table class="editorial-table">
                <thead>
                    <tr>
                        <th>{{ 'contact.editorial.department' | translate }}</th>
                        <th>{{ 'app.location' | translate }}</th>
                        <th>{{ 'contact.editorial.mail' | translate }}</th>
                        <th>{{ 'contact.editorial.phone' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    @for (element of staffTeamRows(); track element.Abteilung + '-' + element.Email) {
                        <tr>
                            <td>{{ element.Abteilung }}</td>
                            <td>{{ element.Standort }}</td>
                            <td>
                                @if (element.Email) {
                                    <span class="contacts-link">
                                        <span class="inline-icon" aria-hidden="true">@</span>
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            [href]="'mailto:' + element.Email"
                                            >{{ element.Email }}</a
                                        >
                                    </span>
                                }
                            </td>
                            <td>{{ element.Phone }}</td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>

        <div class="info">{{ 'contact.editorial.salcontactpersons' | translate }}:</div>
        @for (entry of renderSalTeam(); track entry.Position + '-' + entry.rows.length) {
            <div class="editorial-table-wrapper">
                <table class="editorial-table">
                    <thead>
                        <tr>
                            <th>{{ entry.Position | translate }}</th>
                            <th>{{ 'app.location' | translate }}</th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (element of entry.rows; track element.email + '-' + element.name) {
                            <tr>
                                <td>
                                    <span class="contacts-link">
                                        <a target="_blank" rel="noopener noreferrer" [href]="element.scdLink">{{
                                            element.name
                                        }}</a>
                                        <span class="inline-icon" aria-hidden="true">↗</span>
                                    </span>
                                </td>
                                <td>{{ element.location }}</td>
                                <td>
                                    @if (element.email) {
                                        <span class="contacts-link">
                                            <span class="inline-icon" aria-hidden="true">@</span>
                                            <a [href]="'mailto:' + element.email">{{ element.email }}</a>
                                        </span>
                                    }
                                </td>
                                <td>
                                    <span class="contacts-link">
                                        <a [href]="sanitize(teamsChatEndpoint + element.email)">{{ element.phone }}</a>
                                    </span>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
    </div>
</div>
